import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { useUpdateTag } from 'app/api/tag-queries';

interface SignSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentSignValue: string | null;
  disabled?: boolean;
}

export const SignSwitch = ({ tagId, documentSuperId, currentSignValue, disabled = false }: SignSwitchProps) => {
  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (isNegative: boolean) => {
    updateTag({
      id: tagId,
      documentSuperId,
      sign: isNegative ? '-' : null,
    });
  };

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {i18n('tag.sign.title')}
      </Typography>
      <Form.Check
        type="switch"
        id={`sign-switch-${tagId}`}
        checked={currentSignValue === '-'}
        onChange={(e) => handleUpdate(e.target.checked)}
        disabled={disabled}
        style={disabled ? { cursor: 'not-allowed' } : undefined}
      />
    </div>
  );
};
